import React from 'react';
import Typography from '../../../components/Typography';
import {AbstractRequest} from "../../../api/RequestApi";
import {useTranslation} from "react-i18next";
import {useAuth} from "../../../security/AuthProvider";
import {
    REQUEST_APPROVE_ANY_PERMISSION,
    REQUEST_LEAVES_APPROVE_ANY_PERMISSION,
    REQUEST_LEAVES_REJECT_ANY_PERMISSION
} from "../../../security/Permissions";
import {Modal, ModalActions, ModalBody} from "../../../components/Modal";
import EmployeeAvatar from "../../../components/EmployeeAvatar";
import {Button} from "../../../components/Button";
import {
    BaseRequestDetailModalProps,
    StateBadge,
    TypeBadge
} from "../pending-requests/pending-requests/BaseRequestDetailModal";
import {ApprovalInstance, TimeRecordRequestApprovalInstance} from "../../../api/ApprovalApi";

export function DetailRow({label, children}: { label: string; children: React.ReactNode }) {
    return (
        <div className="flex justify-between items-start py-2 border-b border-gray-100 last:border-b-0">
            <span className="text-sm text-gray-500 shrink-0 mr-4">{label}</span>
            <span className="text-sm text-gray-900 text-right">{children}</span>
        </div>
    );
}

export function DetailSection({title, children}: { title?: string; children: React.ReactNode }) {
    return (
        <div className="mb-4">
            {title && (
                <Typography variant="subtitle2" className="mb-2 text-gray-700">
                    {title}
                </Typography>
            )}
            <div className="rounded-md border border-gray-200 px-3 divide-y divide-gray-100">
                {children}
            </div>
        </div>
    );
}

// export interface BaseApprovalDetailModalProps {
//     approvalInstance: ApprovalInstance;
//     open: boolean;
//     onClose: () => void;
//     onApprove?: (request: ApprovalInstance) => Promise<void>;
//     onReject?: (request: ApprovalInstance) => Promise<void>;
//     approving?: boolean;
//     rejecting?: boolean;
//     /** Type-specific content rendered inside the modal body below the common section. */
//     children?: React.ReactNode;
//     title: string;
// }
//
// export function BaseApprovalDetailModal({
//                                            approvalInstance,
//                                            open,
//                                            onClose,
//                                            onApprove,
//                                            onReject,
//                                            approving = false,
//                                            rejecting = false,
//                                            children,
//                                            title,
//                                        }: BaseApprovalDetailModalProps) {
//
//     const {t, i18n} = useTranslation();
//     const {hasAnyAuthority} = useAuth();
//     const locale = i18n.language === 'de' ? 'de-DE' : 'en-US';
//
//     const canApprove = hasAnyAuthority([REQUEST_APPROVE_ANY_PERMISSION, REQUEST_LEAVES_APPROVE_ANY_PERMISSION]);
//     const canReject = hasAnyAuthority([REQUEST_APPROVE_ANY_PERMISSION, REQUEST_LEAVES_REJECT_ANY_PERMISSION]);
//     const loading = approving || rejecting;
//
//     const employee = approvalInstance.
//
//     const submittedAt = approvalInstance.submittedAt
//         ? new Date(approvalInstance.submittedAt).toLocaleDateString(locale, {
//             day: 'numeric', month: 'long', year: 'numeric',
//         })
//         : '–';
//
//     const handleApprove = async () => {
//         await onApprove?.(approvalInstance);
//         onClose();
//     };
//
//     const handleReject = async () => {
//         await onReject?.(approvalInstance);
//         onClose();
//     };
//
//     return (
//         <Modal isOpen={open} onClose={onClose} size="lg" title={title}>
//             <ModalBody>
//                 {/* Employee header */}
//                 {approvalInstance.employee && (
//                     <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gray-100">
//                         <EmployeeAvatar employee={approvalInstance.employee}/>
//
//                         <div>
//                             <Typography variant="subtitle1" className="font-medium">
//                                 {approvalInstance.employee.preferredName}
//                             </Typography>
//                             {/*{request.employee && (*/}
//                             {/*    <Typography variant="body2" color="secondary">*/}
//                             {/*        {request.employee.jobTitle}*/}
//                             {/*    </Typography>*/}
//                             {/*)}*/}
//                         </div>
//
//                         <div className="ml-auto flex items-center gap-2">
//                             <TypeBadge type={approvalInstance.type}/>
//                             <StateBadge state={approvalInstance.state}/>
//                         </div>
//                     </div>
//                 )}
//
//                 {/* Common metadata */}
//                 <DetailSection title={t('request.detail.metadata')}>
//                     <DetailRow label={t('request.detail.submittedAt')}>
//                         {submittedAt}
//                     </DetailRow>
//
//                     {approvalInstance.description && (
//                         <DetailRow label={t('request.detail.description')}>
//                             {approvalInstance.description}
//                         </DetailRow>
//                     )}
//                 </DetailSection>
//
//                 {/* Type-specific content */}
//                 {children}
//             </ModalBody>
//
//             <ModalActions>
//                 <Button variant="outlined" onPress={onClose} isDisabled={loading}>
//                     {t('common.close')}
//                 </Button>
//
//                 {approvalInstance.state === 'PENDING' && onReject && canReject && (
//                     <Button
//                         variant="outlined"
//                         loading={rejecting}
//                         isDisabled={loading}
//                         onPress={handleReject}
//                     >
//                         {t('request.action.reject')}
//                     </Button>
//                 )}
//
//                 {approvalInstance.state === 'PENDING' && onApprove && canApprove && (
//                     <Button
//                         variant="contained"
//                         loading={approving}
//                         isDisabled={loading}
//                         onPress={handleApprove}
//                     >
//                         {t('request.action.approve')}
//                     </Button>
//                 )}
//             </ModalActions>
//         </Modal>
//     );
// }